import { NavItem } from '../types';

export const navItems: NavItem[] = [
  { labelKey: 'nav.home', routeKey: 'home' },
  { labelKey: 'nav.about', routeKey: 'about' },
  {
    labelKey: 'nav.services',
    routeKey: 'services',
    children: [
      { labelKey: 'services.rehab.name', routeKey: 'serviceDetail', routeParams: { slug: 'rehab' } },
      { labelKey: 'nav.caseStudies', routeKey: 'caseStudies', routeParams: { slug: 'rehab' } },
      { labelKey: 'services.menhely.name', routeKey: 'serviceDetail', routeParams: { slug: 'menhely' } },
      { labelKey: 'services.gazdi.name', routeKey: 'serviceDetail', routeParams: { slug: 'gazdi' } },
    ],
  },
  { labelKey: 'nav.contact', routeKey: 'contact' },
];
